
import {Component, Prop, Vue} from 'vue-property-decorator';
import {RouterNameEnum} from "@/router/router.types";
import {ServiceStore} from "@/store/modules/Services"
import PageTitle from "@/UI/components/common/PageTitle.vue";
import ServiceCreateFormComponent from "@/UI/components/forms/serviceCreate/ServiceCreateFormComponent.vue";
import ServiceGeneralForm from "@/form/serviceGeneral/serviceGeneral";
import {IServicesListItem} from "@/entity/services/services.types";
import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import {getStudioId} from "@/UI/lib/state";
import {FormModel} from "ant-design-vue";

@Component({
  components: {ServiceCreateFormComponent, PageTitle}
})
export default class ServicesUpdate extends Vue {

  form = new ServiceGeneralForm();
  formReady = false;
  formErrors: Record<string, any> = {};

  get service(): IServicesListItem | null {
    return ServiceStore.services;
  }

  async editService(): Promise<void> {
    ((this.$refs.serviceForm as any).$refs.serviceForm as FormModel).validate(async (valid) => {
      const formErrors = Object.keys(this.formErrors);
      if(formErrors.length) {
        for(let i = 0; i < formErrors.length; i++) {
          this.$message.error(this.formErrors[formErrors[i]]);
        }
        valid = false;
      }
      if (valid) {
        if (await this.form.submit(ServiceStore.update)) {
          await ServicesCategoryStore.fetchAll();
          this.form = new ServiceGeneralForm();
          await this.$router.push({name: RouterNameEnum.PartnerServices, params: {Studio: getStudioId(this)}});
        }
      }
    })
  }

  setError(property: string, value: string) {
    this.formErrors[property] = value;
  }

  clearError() {
    this.formErrors = {};
  }

  async created(): Promise<void> {
    await ServiceStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    this.form.setFormData(this.service);
    this.form.price_second = Number(this.service?.price_second)
    this.formReady = true;
  }
}
